module.exports = __webpack_public_path__ + "img/main-background.5a82da71.png";